<h2 mat-dialog-title>
  {{ 'AI_ASSISTANT.SETTINGS.SALES_COACH.SUMMARIZE_AND_SCORE' | translate }}
</h2>

<mat-dialog-content>
  <p>{{ 'AI_ASSISTANT.SETTINGS.SALES_COACH.RAVEN.TITLE' | translate }}</p>
  <ul>
    <li [innerHTML]="'AI_ASSISTANT.SETTINGS.SALES_COACH.RAVEN.R' | translate"></li>
    <li [innerHTML]="'AI_ASSISTANT.SETTINGS.SALES_COACH.RAVEN.A' | translate"></li>
    <li [innerHTML]="'AI_ASSISTANT.SETTINGS.SALES_COACH.RAVEN.V' | translate"></li>
    <li [innerHTML]="'AI_ASSISTANT.SETTINGS.SALES_COACH.RAVEN.E' | translate"></li>
    <li [innerHTML]="'AI_ASSISTANT.SETTINGS.SALES_COACH.RAVEN.N' | translate"></li>
  </ul>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button color="primary" mat-dialog-close>{{ 'AI_ASSISTANT.SHARED.CLOSE' | translate }}</button>
</mat-dialog-actions>
